import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'kh-inner-html-container',
    styleUrls: ['./inner-html-container.component.less'],
    templateUrl: './inner-html-container.component.html',
    standalone: false
})
export class InnerHtmlContainerComponent {
  @Input() public content = '';

}
